import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { BUTTON_SIZES } from 'ui/button';
import { Reset16 } from 'ui/icons/aurora/16px/Reset16';
import { Delete16 } from 'ui/icons/aurora/16px/Delete16';
import { Edit16 } from 'ui/icons/action/Edit16';
import {
  MODAL_NAMES,
  useOrganizationModalsContext,
} from '../../contexts/OrganizationModalsContext';
import { Member } from '../../types';
import { useIsMfaResetAvailable } from '../../hooks';

export const MemberOverflowMenu = ({
  member,
  size = BUTTON_SIZES.LARGE,
}: {
  member: Member;
  size?: BUTTON_SIZES;
}) => {
  const { showModal } = useOrganizationModalsContext();

  const memberIsActive = member?.lastLoginAt;
  const isMfaResetAvailable = useIsMfaResetAvailable(member);

  return (
    <OverflowMenu
      id="member-overflow-menu"
      size={size}
      options={[
        {
          id: 'edit',
          content: (
            <>
              <Edit16 />
              Edit member
            </>
          ),
          as: AllowedActionMenuElements.Button,
          appendDivider: !memberIsActive && !isMfaResetAvailable,
          onClick: () => {
            showModal({
              name: MODAL_NAMES.UPDATE_MEMBER,
              payload: {
                member,
              },
            });
          },
        },
        ...(memberIsActive
          ? [
              {
                id: 'reset-password',
                as: AllowedActionMenuElements.Button,
                content: (
                  <>
                    <Reset16 />
                    Reset password
                  </>
                ),
                appendDivider: !isMfaResetAvailable,
                onClick: () => {
                  showModal({
                    name: MODAL_NAMES.RESET_PASSWORD,
                    payload: { member },
                  });
                },
              },
            ]
          : []),
        ...(isMfaResetAvailable
          ? [
              {
                id: 'reset-multifactor',
                content: (
                  <>
                    <Reset16 />
                    Reset MFA
                  </>
                ),
                onClick: () => {
                  showModal({
                    name: MODAL_NAMES.RESET_MFA,
                    payload: { member },
                  });
                },
                appendDivider: true,
                as: AllowedActionMenuElements.Button,
              },
            ]
          : []),
        {
          id: 'revoke-access',
          content: (
            <>
              <Delete16 />
              Revoke access
            </>
          ),
          onClick: () => {
            showModal({
              name: MODAL_NAMES.REVOKE_ACCESS,
              payload: { member },
            });
          },
          isDestructive: true,
          as: AllowedActionMenuElements.Button,
        },
      ]}
    />
  );
};
